import SingleDisputeDetails from "./SingleDisputeDetails";

export default SingleDisputeDetails;
